import styled from '@emotion/styled'
import React, { useContext } from 'react'
import {
    PRIMARY_PAGE_FILL_COLOR_VAR,
    PRIMARY_PAGE_TEXT_COLOR_VAR,
    SECONDARY_FONT_CSS_VAR,
    SUBTLE_BORDER_COLOR_VAR,
} from '../../../context/CustomizationContextProvider'
import { useColumnCount } from '../../../context/ProductLayoutContext'
import { ViddyLPContext } from '../../../context/viddyLPContext'
import { getTypographyRoleStyle } from '../../../style/typography'
import { TYPOGRAPHY_SIZE } from '../../../style/typographySizes'
import { ItemsGrid } from './PLPDrawer'
import { scaledFontSize } from '../../../style/scrollingLayout'

const SectionContainer = styled.div({
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    borderTop: `1px solid var(${SUBTLE_BORDER_COLOR_VAR})`,
})

const GridContainer = styled.div<{ columnCount: number }>((props) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${props.columnCount}, minmax(0, 1fr))`,
    gridAutoRows: 'auto',
    width: '100%',
    background: `var(${PRIMARY_PAGE_FILL_COLOR_VAR})`,
    paddingTop: 8,
    paddingBottom: 0,
    paddingLeft: 16,
    paddingRight: 16,
    gap: '16px 12px',
    boxSizing: 'border-box',
}))

export const EmptyCartProductGrid: React.FC = () => {
    const columnCount = useColumnCount()
    const { landingPage } = useContext(ViddyLPContext)
    const landingPageLinks = landingPage.landingPageLinks ?? []

    if (landingPageLinks.length === 0) {
        return null
    }

    return (
        <SectionContainer>
            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <h2
                    style={{
                        ...getTypographyRoleStyle('featureTitle', {
                            fontFamily: `var(${SECONDARY_FONT_CSS_VAR})`,
                            fontWeight: 400,
                        }),
                        fontSize: scaledFontSize(TYPOGRAPHY_SIZE.LABEL),
                        marginBottom: 10,
                        paddingTop: 10,
                        color: `var(${PRIMARY_PAGE_TEXT_COLOR_VAR})`,
                    }}
                >
                    You&apos;ll also love
                </h2>
            </div>
            <GridContainer columnCount={columnCount}>
                <ItemsGrid
                    landingPageLinks={landingPageLinks}
                    columnCount={columnCount}
                />
            </GridContainer>
        </SectionContainer>
    )
}
